import { MainInner } from "@/styles/global";
import { Details, DetailsBig, TextLinkCss, h2, h5 } from "@/styles/typography";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Inner = styled(MainInner)`
  padding: 0;
  max-width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    flex-direction: row;
  }
`;

const BackgroundWrapper = styled.div<{ $bgColor: string }>`
  &:first-child {
    background-color: ${({ $bgColor, theme }) =>
      $bgColor === "standard"
        ? theme.colors.coreDark
        : theme.colors.lightGreen};
  }
  &:last-child {
    background-color: ${({ $bgColor, theme }) =>
      $bgColor === "standard"
        ? theme.colors.coreMedium
        : theme.colors.lightPurple};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    &:first-child {
      width: 55%;
      display: flex;
      justify-content: flex-end;
    }
    &:last-child {
      width: 45%;
    }
  }
`;

const LeftWrapper = styled.div`
  padding: 48px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding: 60px 56px 60px 116px;
    max-width: 862px;
  }
`;

const RightWrapper = styled.div`
  padding: 48px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding: 60px 116px 60px 56px;
    max-width: 578px;
  }
`;

const Title = styled(h2)``;

const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    max-width: 862px;

    .newsCard {
      max-width: 400px;
    }
  }
`;

const Card = styled(Link)`
  height: 100%;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.coreLight};
  transition: all 0.3s ease;

  &.newsCard {
    h5 {
      text-decoration: none;
    }
    &:hover {
      span {
        text-decoration-color: ${({ theme }) => theme.colors.textBody};
      }
    }
  }

  &:hover {
    h5 {
      text-decoration-color: ${({ theme }) => theme.colors.textBody};
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: 100%;
    flex-direction: row;
  }
`;

const CardInfo = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;

const CardDetails = styled(DetailsBig)`
  color: ${({ theme }) => theme.colors.textBody};
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  font-size: 12px;

  &:last-child {
    white-space: normal;
  }

  svg {
    margin-bottom: 6px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    font-size: 15px;
  }
`;

const CardDetailsSmall = styled(Details)`
  color: ${({ theme }) => theme.colors.textBody};
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  margin-top: 2px;

  &:last-child {
    white-space: normal;
  }

  svg {
    margin-bottom: 6px;
  }
`;

const TextWrapper = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: 100%;
  }
`;

const CardTitle = styled(h5)`
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: 0.3s;
`;

const CardLink = styled.span`
  ${TextLinkCss}
  color: ${({ theme }) => theme.colors.textBody};
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: 0.3s;
`;

const CardImage = styled(GatsbyImage)`
  aspect-ratio: 16/7;
  border-radius: 4px 4px 0 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    aspect-ratio: 5/4;
    width: 200px;
    border-radius: 4px 0 0 4px;
    display: none;
  }

  @media screen and (min-width: 1170px) {
    display: block;
    min-width: 150px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: start;
  a {
    color: ${({ theme }) => theme.colors.textHeading};

    svg path {
      stroke: ${({ theme }) => theme.colors.textHeading};
    }
  }
`;

const S = {
  Inner,
  BackgroundWrapper,
  LeftWrapper,
  RightWrapper,
  Title,
  CardsWrapper,
  Card,
  CardInfo,
  CardDetails,
  TextWrapper,
  CardTitle,
  CardLink,
  CardImage,
  ButtonWrapper,
  CardDetailsSmall,
};

export default S;
